import { IKnm248 } from 'APIPackage/KnmModule/interfaces/IKnm248';
import { deleteObjectProperties } from 'CorePackage/MainModule/common/deleteObjectProperties';

import { IKnmErknmFormExpert } from '../interfaces/IKnmErknmFormExpert';

export const convertExpertsFormValueToKnmData = (experts: IKnmErknmFormExpert[] | undefined): IKnm248['experts'] => {
  if (!experts) {
    return null;
  }

  return experts.map(item => ({
    title: item.title || null,
    type: item.type ? deleteObjectProperties(item.type, ['label', 'value']) : null,
    guid: item.guid || null,
    dateCreate: item.dateCreate || null,
  }));
};
